import {IconButton, Stack} from '@mui/material'
import NotInterestedIcon from '@mui/icons-material/NotInterested'
import EditIcon from '@mui/icons-material/Edit'
import ClearIcon from '@mui/icons-material/Clear'
import {StyledIconButton} from '../ChatViewStyles'
import {SendOutlined} from '@mui/icons-material'
import PropTypes from 'prop-types'

export const ChatButtons = ({
  editClicked,
  handleClearClick,
  handleEditClick,
  handleSendClick,
  editedPrompt,
  mainPrompt,
  handleCrossClick,
  loader
}) => {
  return (
    <Stack direction="row">
      {editClicked ? (
        <>
          <StyledIconButton
            aria-label="send"
            color="primary"
            size="medium"
            onClick={handleSendClick}
            disabled={editedPrompt.trim() === mainPrompt.trim()}
          >
            <SendOutlined fontSize="medium" />
          </StyledIconButton>
          <IconButton aria-label="clear" color="primary" size="medium" onClick={handleCrossClick}>
            <ClearIcon fontSize="medium" />
          </IconButton>
        </>
      ) : (
        <>
          <StyledIconButton aria-label="clear" size="medium" onClick={handleClearClick} disabled={loader}>
            <NotInterestedIcon fontSize="medium" />
          </StyledIconButton>
          <StyledIconButton aria-label="edit" color="primary" size="medium" onClick={handleEditClick} disabled={loader}>
            <EditIcon fontSize="medium" />
          </StyledIconButton>
        </>
      )}
    </Stack>
  )
}

ChatButtons.propTypes = {
  editClicked: PropTypes.bool.isRequired,
  handleClearClick: PropTypes.func.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  handleSendClick: PropTypes.func.isRequired,
  editedPrompt: PropTypes.string.isRequired,
  mainPrompt: PropTypes.string.isRequired,
  handleCrossClick: PropTypes.func.isRequired,
  loader: PropTypes.bool.isRequired
}
